
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/text-art",
      function () {
        return require("private-next-pages/text-art/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/text-art"])
      });
    }
  